import { tv } from 'tailwind-variants';

import type { VariantProps } from 'tailwind-variants';

const flexContainer = tv({
  base: 'flex min-h-0 min-w-0',
  variants: {
    direction: {
      row: 'flex-row',
      column: 'flex-col',
    },
    items: {
      start: 'items-start',
      center: 'items-center',
      centerSafe: 'items-center-safe',
      end: 'items-end',
      endSafe: 'items-end-safe',
      baseline: 'items-baseline',
      baselineLast: 'items-baseline-last',
      stretch: 'items-stretch',
    },
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      centerSafe: 'justify-center-safe',
      end: 'justify-end',
      endSafe: 'justify-end-safe',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly',
      stretch: 'justify-stretch',
      baseline: 'justify-baseline',
      normal: 'justify-normal',
    },
    wrap: {
      nowrap: 'flex-nowrap',
      wrap: 'flex-wrap',
      wrapReverse: 'flex-wrap-reverse',
    },
    grow: {
      true: 'grow',
      false: 'grow-0',
    },
    shrink: {
      true: 'shrink',
      false: 'shrink-0',
    },
  },
  defaultVariants: {
    direction: 'row',
    items: 'start',
    justify: 'start',
    gap: '0',
    wrap: 'nowrap',
  },
});

interface FlexContainerProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof flexContainer> {
  children: React.ReactNode;
}

function FlexContainer({
  children,
  className,
  direction,
  items,
  justify,
  wrap,
  grow,
  shrink,
  ...rest
}: FlexContainerProps) {
  const classes = flexContainer({ className, direction, items, justify, wrap, grow, shrink });

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export { FlexContainer, flexContainer };
export type { FlexContainerProps };
